import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M20.5 6.4l-11 11L8.1 16l-4.6-4.6L4.9 10l4.6 4.6L19.1 5l1.4 1.4z", clipRule: "evenodd" }));
export {
  l as ReactComponent
};
